import api from './api';
import { VisitaProspeccao } from '../types/visitaProspeccao';

export interface CreateVisitaProspeccaoDTO {
  dataVisita: string;
  dataRetorno?: string;
  cpfCnpj?: string;
  nomeCliente?: string;
  observacao?: string;
  status: 'Agendada' | 'Realizada' | 'Cancelada';
  tipoVisita: 'online' | 'presencial';
  clienteId?: number;
  colaboradorId: number;
  apoliceId?: number;
  telefone?: string;
}

export const visitaProspeccaoService = {
  async getAll(page: number = 1, limit: number = 10): Promise<{ data: VisitaProspeccao[], total: number, page: number, limit: number }> {
    const { data } = await api.get('/visitas-prospeccao', { params: { page, limit } });
    return data;
  },
  async getById(id: number): Promise<VisitaProspeccao> {
    const { data } = await api.get(`/visitas-prospeccao/${id}`);
    return data;
  },
  async create(payload: Omit<VisitaProspeccao, 'id' | 'createdAt' | 'updatedAt' | 'cliente' | 'colaborador' | 'apolice'> & { clienteId: number; colaboradorId: number; apoliceId?: number }): Promise<VisitaProspeccao> {
    const { data } = await api.post('/visitas-prospeccao', payload);
    return data;
  },
  async update(id: number, payload: Partial<Omit<VisitaProspeccao, 'id' | 'createdAt' | 'updatedAt' | 'cliente' | 'colaborador' | 'apolice'>> & { clienteId?: number; colaboradorId?: number; apoliceId?: number }): Promise<VisitaProspeccao> {
    const { data } = await api.put(`/visitas-prospeccao/${id}`, payload);
    return data;
  },
  async delete(id: number): Promise<void> {
    await api.delete(`/visitas-prospeccao/${id}`);
  },
}; 